<template>
    <main class="static-page max-width-container">
        <h1>Contact</h1>
        <p v-if="sent">
            Thanks — your message has been sent. We'll get back to you by email.
        </p>
        <template v-else>
            <p>
                Have a question, or want to access, correct, or delete your
                data? Send us a message and we'll reply by email.
            </p>
            <ContactForm
                ref="form"
                :errors="errors"
                :initial-topic="initialTopic"
                @submit-form="submitForm"
                @clear-error="clearError"
            />
        </template>
    </main>
</template>

<script>
import { useAxiosStore } from "js/stores/axiosStore";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import ContactForm from "js/components/forms/ContactForm";

export default {
    name: "Contact",
    components: {
        ContactForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
            sent: false,
        };
    },
    computed: {
        initialTopic() {
            return this.$route.query.topic ?? "other";
        },
    },
    mounted() {
        this.store = useAxiosStore();
    },
    methods: {
        submitForm(data) {
            this.store
                .create("/api/contact", data)
                .then(() => {
                    this.sent = true;
                })
                .catch((err) => {
                    this.$refs.form?.resetCaptcha();
                    this.handleResponseErrors(err);
                });
        },
    },
};
</script>
